import { MY_DATE_FORMATS } from './shared/datepicker/custom-date-adapter';
var ɵ0 = MY_DATE_FORMATS;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
